import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { ToastService, Toast } from '../../services/toast.service';

@Component({
    selector: 'app-toast',
    imports: [],
    template: `
    <div class="toast-container">
      @for (t of toast.toasts(); track trackById($index, t)) {
        <div
          class="toast toast-{{ t.type }}"
          (click)="toast.dismiss(t.id)">
          <span class="toast-icon">{{ icons[t.type] }}</span>
          <span class="toast-msg">{{ t.message }}</span>
          <button class="toast-close" (click)="toast.dismiss(t.id)">&#x2715;</button>
        </div>
      }
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
    .toast-container {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 380px;
    }
    .toast {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 12px 14px;
      border-radius: 8px;
      font-size: 13px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.12);
      cursor: pointer;
      animation: slideIn 0.2s ease;
      border-left: 4px solid transparent;
    }
    @keyframes slideIn {
      from { transform: translateX(120%); opacity: 0; }
      to   { transform: translateX(0);    opacity: 1; }
    }
    .toast-success { background:#F0FDF4; border-color:#16A34A; color:#15803D; }
    .toast-error   { background:#FEF2F2; border-color:#DC2626; color:#B91C1C; }
    .toast-warning { background:#FFFBEB; border-color:#D97706; color:#B45309; }
    .toast-info    { background:#EFF6FF; border-color:#2563EB; color:#1D4ED8; }
    .toast-icon    { font-size: 15px; flex-shrink: 0; margin-top: 1px; }
    .toast-msg     { flex: 1; line-height: 1.5; }
    .toast-close   {
      background: none; border: none; cursor: pointer; opacity: 0.5;
      font-size: 12px; padding: 0; color: inherit; flex-shrink: 0;
    }
    .toast-close:hover { opacity: 1; }
  `]
})
export class ToastComponent {
  toast = inject(ToastService);
  icons: Record<string, string> = {
    success: '✅',
    error:   '❌',
    warning: '⚠️',
    info:    'ℹ️'
  };
  trackById(_: number, t: Toast) { return t.id; }
}
